import React from 'react';
import VerifiedEditHobbies from './VerifiedEditHobbies';
import VerifyEditAccess from 'components/VerifyEditAccess';
import NoAccess from 'components/NoAccess';

const EditHobbies = () => {
  return (
    <VerifyEditAccess>
      {(id, canEdit, navigate) =>
        canEdit ? (
          <VerifiedEditHobbies id={id} navigate={navigate} />
        ) : (
          <NoAccess />
        )
      }
    </VerifyEditAccess>
  );
};

export default EditHobbies;
